class ProductCountdown {
  constructor(element) {
    this.element = element;
    this.timerEl = element?.querySelector('.countdown-timer');
    this.interval = null;
    this.init();
  }

  hide() {
    this.element.style.display = 'none';
    const parentBlock = this.element.closest('.shopify-block[id*="custom_product_countdown"]');
    if (parentBlock) parentBlock.style.display = 'none';
  }

  init() {
    if (!this.element || !this.timerEl) return;

    const { validTo, validFrom, isDate } = this.element.dataset;
    if (!validTo) return this.hide();

    const parseTime = (val) => isDate === 'true' ? new Date(val).getTime() : parseInt(val) * 1000;
    this.endTime = parseTime(validTo);
    this.startTime = validFrom ? parseTime(validFrom) : null;
    const now = Date.now();

    if (this.startTime && now < this.startTime) {
      this.hide();
      if (this.startTime - now < 86400000) {
        setTimeout(() => this.init(), this.startTime - now + 1000);
      }
      return;
    }

    if (isNaN(this.endTime) || this.endTime <= now) return this.hide();

    this.element.style.display = '';
    const parentBlock = this.element.closest('.shopify-block[id*="custom_product_countdown"]');
    if (parentBlock) parentBlock.style.display = 'block';

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const distance = this.endTime - Date.now();
    if (distance < 0) {
      this.timerEl.textContent = '00:00:00';
      return this.destroy();
    }

    const d = Math.floor(distance / 86400000);
    const h = Math.floor((distance % 86400000) / 3600000);
    const m = Math.floor((distance % 3600000) / 60000);
    const s = Math.floor((distance % 60000) / 1000);

    const l = this.element.dataset.heroBanner === 'true' ? 'DHMS' : 'dhms';
    const timeText = d > 0
      ? `${String(d).padStart(2, '0')}${l[0]} ${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
      : h > 0 ? `${h}${l[1]} ${m}${l[2]} ${s}${l[3]}`
        : `${m}${l[2]} ${s}${l[3]}`;

    this.timerEl.textContent = timeText;
    this.timerEl.classList.remove('countdown-timer--loading');
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateTimestamp(validTo) {
    this.destroy();
    this.timerEl?.classList.add('countdown-timer--loading');
    this.endTime = parseInt(validTo) * 1000;
    this.init();
  }
}

function initializeCountdowns() {
  document.querySelectorAll('.custom-product-countdown:not([data-initialized])').forEach((el) => {
    el.setAttribute('data-initialized', 'true');
    el._countdownInstance = new ProductCountdown(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCountdowns);
} else {
  initializeCountdowns();
}

new MutationObserver(initializeCountdowns)
  .observe(document.body, { childList: true, subtree: true });

document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  if (!html) return;

  html.querySelectorAll('.custom-product-countdown').forEach((newCountdown) => {
    const current = document.getElementById(newCountdown.id);
    if (!current) return;

    const instance = current._countdownInstance;
    const { validTo: newTo, validFrom: newFrom } = newCountdown.dataset;
    const changed = newTo !== current.dataset.validTo || newFrom !== current.dataset.validFrom;

    if (instance && changed) {
      if (newTo) current.dataset.validTo = newTo;
      else delete current.dataset.validTo;
      if (newFrom) current.dataset.validFrom = newFrom;
      else delete current.dataset.validFrom;

      newTo ? instance.updateTimestamp(newTo) : (instance.destroy(), instance.hide());
    } else if (!instance && newTo) {
      current._countdownInstance = new ProductCountdown(current);
    }
  });
});
